import ConsumerIntegrationsList from './ConsumerIntegrationsList';

export default ConsumerIntegrationsList;
